import InputField from 'components/fields/InputField';
import React, { useEffect, useState } from 'react';

const ContactInformation = ({ schoolData, handleChange, setDisable }) => {
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const newErrors = [];

    // Check if contactPhone is provided
    if (!schoolData?.contactPhone) {
      newErrors.push('Contact Phone is required.');
    }

    setErrors(newErrors);

    // Enable/disable the next button based on errors
    setDisable(newErrors.length > 0);
  }, [schoolData, setDisable]);

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Header */}
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Contact Information
      </h4>
      {/* content */}
      <div className="mx-auto mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
        <InputField
          maxLength={100}
          extra="mb-3"
          label="Email"
          placeholder="eg. example@example.com"
          id="email"
          type="email"
          name="email"
          onChange={handleChange}
          value={schoolData?.email}
          readOnly={true}
        />
        <InputField
          extra="mb-3"
          label="Contact Phone"
          placeholder="eg. 1234567890"
          id="contactPhone"
          type="number"
          name="contactPhone"
          maxLength={12}
          onChange={handleChange}
          value={schoolData?.contactPhone}
        />
        {/* Display errors */}
        {errors.length > 0 && (
          <div className="text-red-500">
            {errors.map((error, index) => (
              <p key={index}>{error}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactInformation;
